define(function(require) {
    var $ = require('jquery');
    var Base = require('../../core/base/base');

    var Dnd = Base.extend({
        propsInAttrs: ['element', 'handle'],

        // 拖放的元素，即源节点
        element: null,

        // 触发拖放的元素，该元素必须在element内部
        // 默认为element
        handle: null,

        attrs: {
            // 拖放边界，默认为document
            // element必须要位于containment内部
            containment: {
                value: $(document),
                setter: function(val) {
                    return $(val).eq(0);
                }
            },

            // 代理元素。实际上跟随鼠标移动的元素，默认null为源节点element的clone
            proxy: {
                value: null,
                setter: function(val) {
                    return $(val).eq(0);
                }
            },

            // 可放置容器，默认null为无
            drops: {
                value: null,
                setter: function(val) {
                    return $(val);
                }
            },

            // 是否禁止该元素拖放，默认false为不禁止
            disabled: false,

            // 被拖放的元素在源位置上是否可见，默认为false不可见
            visible: false,

            // 拖放指定的方向，默认false为任意方向
            axis: false,

            // 是否返回源节点初始位置，默认false不返回
            revert: false,

            // 返回速度，默认为500ms
            // 源节点显示（visible=true）时，拖放结束时移动到拖放位置的速度也取此值
            revertDuration: 500,

            // 拖放过程中没进入放置容器drop时光标的形状，默认为'move'
            dragCursor: 'move',

            // 拖放过程中进入放置容器drop时光标的形状，默认为'copy'
            dropCursor: 'copy',

            // 代理元素proxy拖放过程中的z-index，默认为9999
            zIndex: 9999
        },

        initialize: function(config) {
            Dnd.superclass.initialize.call(this, config);
            // 用来记录一些运行时的信息
            this.options = {
                id: 'dnd-' + new Date().getTime(),
                dragPre: false,
                draging: false,
                drop: null,                     // 当前可放置容器，drops则为设置的可放置容器
                diffX: 0,                       // 记录鼠标点击离源节点的距离
                diffY: 0,
                dataTransfer: {},               // 存储拖放信息，在dragstart可设置，在drop中可读取
                next: true                     // 标识是否可以执行下一次拖放。当使用动画时，动画结束后会释放proxy，而此时proxy元素可能已经改变
            };

            this.element = $(this.element);
            if (this.element.length === 0) {
                $.error('Dnd element error');
            }
            this.handle = $(this.handle);
            if (this.handle.length === 0 || !$.contains(this.element[0], this.handle[0])) {
                this.handle = this.element;
            }
            this.handle.css('cursor', 'move');

            this.setup();
        },

        setup: function() {
            this.handle.on('mousedown', $.proxy(this._handleMouseDown, this));
            $(document).on('mousemove.' + this.options.id, $.proxy(this._handleMouseMove, this));
            $(document).on('mouseup.' + this.options.id, $.proxy(this._handleMouseUp, this));
        },

        destroy: function() {
            $(document).off('mousemove.' + this.options.id);
            $(document).off('mouseup.' + this.options.id);
            Dnd.superclass.destroy.call(this);
        },

        _handleMouseDown: function(evt) {
            var proxy, diffX, diffY;

            if (this.options.next) {
                // 不允许拖放则返回
                if (this.get('disabled')) return;

                // 初始化proxy
                if (!this.get('proxy')) {
                    proxy = this.element.clone();
                } else {
                    proxy = this.get('proxy');
                }

                // 设置代理元素proxy，并将其插入element的父元素中
                // 这样保证proxy的样式与源节点element一致
                proxy.css({
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    visibility: 'hidden'
                });
                proxy.appendTo(this.element.parent());

                // 使代理元素定位到element处
                proxy.data('originx', proxy.offset().left);
                proxy.data('originy', proxy.offset().top);
                proxy.css({
                    left: this.element.offset().left - proxy.data('originx'),
                    top: this.element.offset().top - proxy.data('originy'),
                    width: this.element.width(),
                    height: this.element.height()
                });

                // 记录鼠标点击位置与源节点element的距离
                diffX = evt.pageX - this.element.offset().left;
                diffY = evt.pageY - this.element.offset().top;

                $.extend(this.options, {
                    dragPre: true,
                    proxy: proxy,
                    diffX: diffX,
                    diffY: diffY
                });
            }

            if (this.options.dragPre) {
                evt.preventDefault();
            }
        },

        _handleMouseMove: function(evt) {
            if (this.options.dragPre) {
                // 开始拖放
                this._executeDragStart();
            } else if (this.options.draging) {
                // 根据边界和方向一起判断是否drag并执行
                this._executeDrag({
                    pageX: evt.pageX,
                    pageY: evt.pageY
                });

                // 根据proxy和可放置容器的相互位置来判断
                // 是否要dragenter, dragleave和dragover并执行
                this._executeDragEnterLeaveOver();

                // 阻止默认选中文本
                evt.preventDefault();
            }
        },

        _handleMouseUp: function(evt) {
            var options = this.options;
            if (options.dragPre) {
                // 点击而非拖放
                options.proxy.remove();
                options.proxy = null;
                options.dragPre = false;
            } else if (options.draging) {
                options.draging = false;
                options.next = false;
                options.proxy.css('cursor', 'default');
                options.proxy.focus();

                // 根据当前的可放置容器判断是否drop并执行
                this._executeDrop();

                // 根据revert属性判断是否要返回并执行
                this._executeRevert();
            }
        },

        // 鼠标拖动触发拖放
        _executeDragStart: function() {
            var visible = this.get('visible');
            var dragCursor = this.get('dragCursor');
            var zIndex = this.get('zIndex');
            var options = this.options;

            // 按照设置显示或隐藏element
            if (!visible) {
                this.element.css('visibility', 'hidden');
            }

            // 显示proxy
            options.proxy.css({
                'z-index': zIndex,
                visibility: 'visible',
                cursor: dragCursor
            });
            options.proxy.focus();

            options.dataTransfer = {};
            options.dragPre = false;
            options.draging = true;
            this.trigger('dragstart', options.dataTransfer, options.proxy);
        },

        // 根据边界和方向一起判断是否drag并执行
        _executeDrag: function(evt) {
            var options = this.options;
            var containment = this.get('containment');
            var axis = this.get('axis');
            var xleft = evt.pageX - options.diffX;
            var xtop = evt.pageY - options.diffY;
            var originx = options.proxy.data('originx');
            var originy = options.proxy.data('originy');
            var offset = containment.offset();

            // containment is document
            // 不用 === 是因为 jquery 版本不同，返回值也不同
            if (!offset) {
                offset = {left:0, top:0};
            }

            // 是否在x方向上移动并执行
            if (axis !== 'y') {
                if (xleft >= offset.left &&
                    (xleft + options.proxy.outerWidth()) <= (offset.left + containment.outerWidth())) {
                    options.proxy.css('left', xleft - originx);
                } else {
                    if (xleft <= offset.left) {
                        options.proxy.css('left', offset.left - originx);
                    } else {
                        options.proxy.css('left',
                            offset.left + containment.outerWidth() -
                            options.proxy.outerWidth() - originx);
                    }
                }
            }

            // 是否在y方向上移动并执行
            if (axis !== 'x') {
                if (xtop >= offset.top &&
                    (xtop + options.proxy.outerHeight()) <= (offset.top + containment.outerHeight())) {
                    options.proxy.css('top', xtop - originy);
                } else {
                    if (xtop <= offset.top) {
                        options.proxy.css('top', offset.top - originy);
                    } else {
                        options.proxy.css('top',
                            offset.top + containment.outerHeight() -
                            options.proxy.outerHeight() - originy);
                    }
                }
            }

            this.trigger('drag', options.proxy, options.drop);
        },

        // 根据proxy和可放置容器的相互位置来判断是否dragenter, dragleave和dragover并执行
        _executeDragEnterLeaveOver: function() {
            var self = this;
            var options = this.options;
            var drops = this.get('drops');
            var dragCursor = this.get('dragCursor');
            var dropCursor = this.get('dropCursor');
            var xleft = options.proxy.offset().left + options.diffX;
            var xtop = options.proxy.offset().top + options.diffY;

            if (drops === null) {
                return;
            }

            if (options.drop === null) {
                $.each(drops, function (index, elem) {
                    if (isContain(elem, xleft, xtop) === true) {
                        options.proxy.css('cursor', dropCursor);
                        options.proxy.focus();

                        options.drop = $(elem);
                        self.trigger('dragenter', options.proxy, options.drop);
                        return false; // 跳出each
                    }
                });
            } else {
                if (isContain(options.drop, xleft, xtop) === false) {
                    options.proxy.css('cursor', dragCursor);
                    options.proxy.focus();

                    self.trigger('dragleave', options.proxy, options.drop);
                    options.drop = null;
                } else {
                    self.trigger('dragover', options.proxy, options.drop);
                }
            }
        },

        // 根据proxy和当前的可放置容器地相互位置判断是否drop并执行
        // 当proxy不完全在drop内且不需要revert时，将proxy置于drop中央
        _executeDrop: function() {
            var options = this.options;
            var revert = this.get('revert');
            var originx = options.proxy.data('originx');
            var originy = options.proxy.data('originy');

            if (options.drop === null) {
                return;
            }

            // 放置时不完全在drop中并且不需要返回的则放置中央
            if (isContain(options.drop, options.proxy) === false && revert === false) {
                options.proxy.css('left', options.drop.offset().left +
                        (options.drop.outerWidth() - options.proxy.outerWidth()) / 2 - originx);
                options.proxy.css('top', options.drop.offset().top +
                        (options.drop.outerHeight() - options.proxy.outerHeight()) / 2 - originy);
            }

            this.trigger('drop', options.dataTransfer, options.proxy, options.drop);
        },

        // 根据revert判断是否要返回
        // 若可放置容器drops不为null且当前可放置容器drop为null，则自动回到原处
        // 处理完移除代理元素
        _executeRevert: function() {
            var self = this;
            var options = this.options;
            var drops = this.get('drops');
            var revert = this.get('revert');
            var revertDuration = this.get('revertDuration');
            var visible = this.get('visible');
            var zIndex = this.get('zIndex');
            var xleft = options.proxy.offset().left - this.element.offset().left;
            var xtop = options.proxy.offset().top -  this.element.offset().top;
            var originx = options.proxy.data('originx');
            var originy = options.proxy.data('originy');

            if (revert || (options.drop === null && drops !== null)) {

                //代理元素返回源节点初始位置
                options.proxy.animate({
                    left: this.element.offset().left - originx,
                    top: this.element.offset().top - originy
                }, revertDuration, function () {
                    self.element.css('visibility', '');
                    options.proxy.remove();
                    options.proxy = null;

                    // 触发dragend
                    self.trigger('dragend', self.element, options.drop);
                    options.drop = null;
                    options.next = true;
                });

            } else {
                // 源节点移动到代理元素处
                if (this.element.css('position') === 'relative') {
                    xleft = (isNaN(parseInt(this.element.css('left'), 10)) ? 0 :
                        parseInt(this.element.css('left'), 10)) + xleft;
                    xtop = (isNaN(parseInt(this.element.css('top'), 10)) ? 0 :
                        parseInt(this.element.css('top'), 10)) + xtop;
                } else if (this.element.css('position') === 'absolute') {
                    xleft = options.proxy.offset().left - originx;
                    xtop = options.proxy.offset().top - originy;
                } else {
                    this.element.css('position', 'relative');
                }

                if (visible === false) {
                    this.element.css({
                        left: xleft,
                        top: xtop,
                        visibility: '',
                        'z-index': zIndex
                    });
                    options.proxy.remove();
                    options.proxy = null;

                    // 触发dragend
                    this.trigger('dragend', this.element, options.drop);
                    options.drop = null;
                    options.next = true;

                } else {
                    // 源节点显示时，动画移动到代理元素处
                    this.element.animate({
                        left: xleft,
                        top: xtop
                    }, revertDuration, function () {
                        options.proxy.remove();
                        options.proxy = null;

                        // 触发dragend
                        self.trigger('dragend', self.element, self.drop);
                        options.drop = null;
                        options.next = true;
                    });
                }
            }
        }
    });

    /**
     * 暴露该方法来批量初始化拖放元素
     */
    Dnd.initialize = function(elems, config) {
        $(elems).each(function(i, elem) {
            new Dnd($.extend({
                element: elem
            }, config));
        });
    };

    // Helpers
    // -------

    /**
     * 判断元素B是否位于元素A内部
     * or 点(B, C)是否位于A内
     */
    function isContain(A, B, C) {
        var offset = $(A).offset();

        // A is document
        if (!offset) {
            offset = {left:0, top:0};
        }

        if (arguments.length === 2) {
            return offset.left <= $(B).offset().left &&
                offset.left + $(A).outerWidth() >=
                $(B).offset().left + $(B).outerWidth() &&
                offset.top <= $(B).offset().top &&
                offset.top + $(A).outerHeight() >=
                $(B).offset().top + $(B).outerHeight();
        }
        if (arguments.length === 3) {
            return offset.left <= B &&
                offset.left + $(A).outerWidth() >= B &&
                offset.top <= C &&
                offset.top + $(A).outerHeight() >= C;
        }
    }


    return Dnd;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/cui/util/dnd/dnd.js
 ** module id = 83
 ** module chunks = 13 14
 **/